"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _HandleRoundedArrow = require("./HandleRoundedArrow");
var _TabPanel = require("./TabPanel");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const COMPONENT_MODES = {
  DEFAULT: 'default',
  GROW: 'grow'
};
const Tabs = _ref => {
  let {
    children,
    screenSize,
    color,
    variant,
    onChange,
    selectedTabIndex,
    showDivider,
    mode
  } = _ref;
  const classes = (0, _styles.default)();
  const [value, setValue] = (0, _react.useState)(selectedTabIndex);
  const handleChange = (_event, newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  const handleSize = () => {
    const isMobile = screenSize === 'mobile';
    const maxWidth = isMobile ? 309 : 480;
    if (mode === COMPONENT_MODES.GROW && isMobile) return {
      maxWidth
    };
    if (mode === COMPONENT_MODES.GROW) return {};
    if (isMobile) return {
      maxWidth,
      maxHeight: 36
    };
    return {
      maxWidth,
      maxHeight: 48
    };
  };
  (0, _react.useEffect)(() => {
    setValue(selectedTabIndex);
  }, [selectedTabIndex]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    sx: handleSize()
  }, /*#__PURE__*/_react.default.createElement(_core.Tabs, {
    value: value,
    onChange: handleChange,
    indicatorColor: color,
    textColor: color,
    variant: variant,
    scrollButtons: "auto",
    allowScrollButtonsMobile: true,
    "aria-label": "scrollable force tabs example",
    ScrollButtonComponent: props => /*#__PURE__*/_react.default.createElement(_HandleRoundedArrow.HandleRoundedArrow, {
      props: props,
      screenSize: screenSize
    })
  }, children.map((tab, index) => /*#__PURE__*/_react.default.createElement(_core.Tab, {
    "aria-label": "teste",
    id: `tab-${index + 1}`,
    label: tab.label,
    icon: tab.icon,
    classes: {
      root: (0, _classnames.default)(classes.tab, screenSize === 'mobile' && classes.tabButtonMobile, mode === COMPONENT_MODES.GROW && classes.growModeTab)
    },
    disabled: tab.disabled
  })))), children.map((tab, index) => /*#__PURE__*/_react.default.createElement(_TabPanel.TabPanel, {
    value: value,
    index: index
  }, showDivider && /*#__PURE__*/_react.default.createElement(_core.Divider, null), tab.content)));
};
exports.Tabs = Tabs;
Tabs.propTypes = {
  /**
   * Conteúdo a ser exibido quando uma Tab é selecionada. <br>
   * Deverá ser passado um array de objetos com as chaves: <br>
   * Label: string <br>
   * Content: componente <br>
   * Disabled: opcional - {true} <br>
   * icon: opcional um icone para ser exibido na tabtab.icon
   * Obs.: o componente Tabs não faz nenhuma alteração de CSS no componente utilizado como Content.
   */
  children: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /**
   * Tamanho do componente de acordo com a tela
   */
  screenSize: _propTypes.default.oneOf(['desktop', 'mobile']),
  /**
   * Cores do componente
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * Opção para ativar o scroll da Tab
   */
  variant: _propTypes.default.oneOf(['scrollable', null]),
  /**
   * Função que será chamada ao ocorrer uma mudança de tab
   */
  onChange: _propTypes.default.func,
  /**
   * Permite controlar a tab em exibição programaticamente, e/ou iniciar em uma tab específica
   */
  selectedTabIndex: _propTypes.default.number,
  /**
   * Controla a exibição de um divider abaixo da tab
   */
  showDivider: _propTypes.default.bool,
  /**
   * Alterna entre os modos
   * modo `grow` - permitte a tab crescer
   */
  mode: _propTypes.default.oneOf([COMPONENT_MODES.DEFAULT, COMPONENT_MODES.GROW])
};
Tabs.defaultProps = {
  screenSize: 'desktop',
  color: 'primary',
  variant: '',
  onChange: null,
  selectedTabIndex: 0,
  showDivider: false,
  mode: COMPONENT_MODES.DEFAULT
};
var _default = exports.default = Tabs;